import type { PunchItemPriority } from '../../types'

const priorityMap: Record<PunchItemPriority, string> = {
  Critical: 'priority-badge critical',
  High: 'priority-badge high',
  Medium: 'priority-badge medium',
  Low: 'priority-badge low',
}

interface PriorityBadgeProps {
  priority: PunchItemPriority
}

export function PriorityBadge({ priority }: PriorityBadgeProps) {
  return <span className={priorityMap[priority]}>{priority}</span>
}
